<!-- Main content multiple tabs -->
<!-- <div class="content__wrapper partner_content"> -->

<!-- Tab content - each tab -->
<!-- <div class="tab-content" id="partnerContentTabs"> -->
<div class="show fade" id="authorsTab">
  <div class="d-flex flex-column h-100" id="authorsTabFlex">
    <!-- Data heading and info -->
    <div class="data_header" id="authorsDataHeader">
      <div class="left_side_section" id="authorsSideSec">
        <div class="results_info" id="resultsInfoAuthor">
          <div class="title" id="authorsTitle"><span i18n="@@author.title.authors">Authors</span></div>
          <div class="results" id="resShowingFrmTo">
            <span i18n="@@author.showing-pagination.showing">Showing <strong>{{showFrom}} - {{showTo}} </strong> of <strong>{{authorsCount}} Authors</strong></span> 
          </div>
        </div>
        <div class="search_group" *ngIf="authorUserdata?.length > 0 || showSearchgBar" id="authorsSearchGrp">
          <div class="input-group" id="authorsInputGrp">
            <input  #searchValue [(ngModel)]="searchData" (keyup.enter)="searchByPartnername(searchData)" type="text" value="" id="partnerSearch"
             class="form-control" [placeholder]="searchPlaceholder"/>
              <img  [alt]="AltcloseText" *ngIf="searchClose && searchData?.length" (click)="clearSearch()"
              class="search-clear-icon" />
          </div>
          <button type="button" class="btn btn-primary search_btn gtmAuthorSearch">
            <img class="search_icon" [alt]="AltsearchText" (click)="searchByPartnername(searchData)" />
          </button>
        </div>
      </div>
      <div class="action_buttons" *ngIf="authorUserdata?.length > 0" id="inviteNewAuthor">
        <button type="button" class="btn btn-primary btn-lg left_icon_btn gtmUsersNewUser" (click)="inviteNewAuthor()"
          data-toggle="modal" data-target="#addAuthorPopup">
          <img class="plus-square" [alt]="AltNewAuthorText" />
          <span i18n="@@author.button-label.new-author">New Author</span>
        </button>
      </div>
    </div>
    <hr />

    <div [ngClass]="isAuthorDataEmpty && !dataSearch ? 'existing_author_show': 'existing_author_hide'" id="noOEMAuthorsMainDiv"> 
      <div class="allign_text" id="noOEMAuthorsChildDiv"><span i18n="@@author.no-data-desc.there-no-oem">There are no OEM Authors yet.</span></div>
      <div class="action_buttons button_center" id="inviteNewAuthor">
        <button type="button" class="btn btn-primary btn-lg left_icon_btn gtmUsersNewUser" (click)="inviteNewAuthor()"
          data-toggle="modal" data-target="#addAuthorPopup">
          <img class="plus-square" [alt]="AltNewAuthorText" />
          <span i18n="@@author.button-label.new-author">New Author</span>
        </button>
      </div>
    </div>

    <div class="text-center" *ngIf="authorUserdata?.length === 0 && dataSearch" id="noRecordsFound">
      <span i18n="@@author.no-data-partner.no-record-found">No Records Found</span>
     </div>

    <!-- Table data -->
    <iposcen-spinner-overlay></iposcen-spinner-overlay>
    <div [ngClass]="!isAuthorDataEmpty ? 'existing_author_show': 'existing_author_hide'" id="isAuthorDataEmpty">
      <div class="table-responsive" id="tblResponsive">
        <table id="authorsTable" class="table table-borderless" aria-describedby="authorsTable">
          <thead *ngIf="!isSearchData">
            <tr>
              <th scope="col">
                <span class="table_headings" (click)="sort(email)">
                  <span i18n="@@author.table-heading.email-id">Email ID</span>
                  <span class="chevron_expand"></span>
                </span>
              </th>
              <th scope="col">
                <span class="table_headings" (click)="sort(name)">
                  <span i18n="@@author.table-heading.name">Name</span>
                  <span class="chevron_expand"></span>
                </span>
              </th>
              <th scope="col">
                <span class="table_headings" (click)="sort(partnerSort)">
                  <span i18n="@@author.table-heading.partner">Partner</span>
                  <span class="chevron_expand"></span>
                </span>
              </th>
              <th scope="col">
                <span class="table_headings" (click)="sort(location)">
                  <span i18n="@@author.table-heading.location">Location</span>
                  <span class="chevron_expand"></span>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let author of authorUserdata" class="row_hover">
              <td>{{author.email}}</td>
              <td>{{author.name}}</td>
              <td>{{author.partnerName}}</td>
              <td>{{author.location}}</td>
              <td class="action_cell">
                <button type="button" id="delete_button" class="btn btn-link delete-user" [ngbTooltip]="deleteTooltip"
                (click)="showDeleteUserPopup(author.userID, author.name)">
                  <img class="deleteicon" [alt]="AltdeleteText" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <hr />

    <!-- Pagination -->
    <div class="data_footer position-relative" *ngIf="authorUserdata.length > 0" id="dataFooterPagination">
      <div class="d-flex flex-column align-items-center" id="authorsPagination">
        <nav aria-label="Authors pagination">
          <ngb-pagination [collectionSize]="authorsCount" [(page)]="page" [pageSize]="tableSize"
          [rotate]="false" [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false"
          (pageChange)="onTableDataChange($event)">
        </ngb-pagination>
        </nav>
        <div class="results mt-2" *ngIf='authorUserdata.length' id="authorsUsrData">
          <span i18n="@@author.showing-pagination.showing">Showing <strong>{{showFrom}} - {{showTo}} </strong> of <strong>{{authorsCount}} Authors</strong></span>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- </div> -->
<!-- </div> -->

<!-- Add New Author Popup -->
<div class="container" *ngIf="showInvitePopup" id="containerNewAuthor">
  <div class="modal-backdrop show" id="modalBackDrop"></div>
  <div class="modal show fade" id="addAuthorPopup">
    <div class="modal-dialog modal-dialog-centered" id="addAuthorPopupDialog">
      <form [formGroup]="inviteAuthorForm">
        <div class="modal-content" id="addAuthorModalCon">
          <div class="close" data-dismiss="modal" (click)="onCloseInvite()" id="addAuthorPopupClose">
            <img class="modal-close-icon" [alt]="AltcloseText" />
          </div>
          <div class="modal-body location-search" id="addAuthorModalBody">
            <div class="heading" id="inviteAuthorHeader"><span i18n="@@author.popup-heading-author.invite-author">Invite Author</span></div>
            <div class="d-flex" id="addAuthorPopupFlex">
              <div class="form-group" #wrap>
                <label for=""><span i18n="@@author.form-lable.email-address">Email Addresses</span>&nbsp;<span class="coral">*</span></label>
                <div class="invite-users-note"><span>{{inviteUserNote}}</span></div>
                <div class="form-group form-group-md multi_email" [ngClass]="{'invalid-user-identification': isUserValid}" #wrap>
                  <div class="global-filter-chips" id="globalFilterChips">
                    <div class="global-filter-chip" *ngFor="let email of userEmailAddresses;  let i= index" id="globalFilterChip">
                      <span class="global-filter-chip-text" (dblclick)="editEmail(i)">
                        {{email}}
                      </span>
                      <div class="remove-global-filter-btn" (click)="deleteEmail(i)" id="deleteEmailBtn">
                        <img class="modal-close-icon" [alt]="AltcloseText" />
                      </div>
                    </div>
                  </div>
                  <div *ngIf="checkEdit" id="avoidSpecialChar">
                    <input type="text" [placeholder]="" (paste)="onPaste($event)" (keyup)="onKeyUp($event)"
                      class="form-control" formControlName="emailAddress" (input)="avoidSpecialChar($event)"
                      class="editEmail">
                  </div>
                  <textarea *ngIf="!checkEdit" rows="1" id="email" name="email" class="form-control"
                    formControlName="emailAddress"
                    [placeholder]="userEmailAddresses?.length ? '':(enterAllEmailPlaceholderText)" required value=''
                    (keyup)="onKeyUp($event)" (focus)="addBorder(wrap)" (paste)="onPaste($event)"
                    (input)="avoidSpecialChar($event)" (blur)="removeBorder(wrap)"></textarea>
                </div>
                <div *ngIf="!isEmailrequired" class="formfield_err_msg" id="isEmailRequired"><span i18n="@@author.error-message.required-field">This is a required field.</span></div>
                <div class="formfield_err_msg" *ngIf="!isEmailValid" id="isEmailValid"><span i18n="@@author.error-message.valid-email">Please provide a valid email address.</span></div>
                <div class="formfield_err_msg" *ngIf="checkDuplicate" id="checkDuplicateEmail"><span i18n="@@author.error-message.email-already-added">Email already added</span></div>
                <div class="formfield_err_msg" *ngIf="checkDuplicateCount>0" id="checkDuplicateCount"><span i18n="@@author.error-message.email-already-registered">Email already Registered</span></div>
                <div class="formfield_err_msg invalid-user-error error-msg-width" *ngIf="isUserValid" id="invalidUser">
                <span>{{invalidUserErrorPretitle}} {{invalidUserErrorPosttitle}}</span>
                <div style="font-weight: bold;" *ngFor="let email of invalidUserEmails">{{email}}</div>
              </div>              
              </div>
              <div class="ml-4 mr-4" id="authorsFrmMainDiv">
                <div class="form-group" id="frmLblLocation">
                  <label for=""><span i18n="@@author.form-lable.location">Location</span>&nbsp;<span class="coral">*</span></label>
                  <div class="drop-search" id="dropSearch">
                  <ng-select [items]="allLocations" placeholder="{{ locationSearch }}"
                  bindLabel="CountryName" name="country" [clearable]="true" [searchFn]="countrySearchFn"
                  [(ngModel)]="locationLabel" [ngModelOptions]="{standalone: true}" [selectOnTab]="true" (change)="onLocationSelect($event)">
                </ng-select>
                <div *ngIf="!locationLabel" class="search-icon" id="searchIcon"></div>
                  </div>
                  <div *ngIf="!locationLabel && isSubmitted" class="formfield_err_msg" id="authorRquiredFld"><span i18n="@@author.error-message.required-field">This is a required field.</span></div>
                </div>
                <div class="form-group" id="frmLblPartner">
                  <label for=""><span i18n="@@author.form-lable.partner">Partner</span>&nbsp;<span class="coral">*</span></label>
                  <div class="drop-search" id="dropSearchPartner">
                  <ng-select [items]="partnerDetails" placeholder ="{{ partnerSearch }}"
                  bindLabel="partnerName" bindValue="partnerId" name="store-drop" [clearable]="true" [(ngModel)]="partnerLabel"
                  [ngModelOptions]="{standalone: true}" [selectOnTab]="true" (change)="onPartnerSelect($event)">
                </ng-select>
                <div *ngIf="!partnerLabel" class="search-icon" id="searchIconPartnerLbl"></div>
                </div>
                  <div *ngIf="!partnerLabel && isSubmitted" class="formfield_err_msg" id="frmFldErrMsg"><span i18n="@@author.error-message.required-field">This is a required field.</span></div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" id="modalFooterBtns">
            <button type="button" class="btn btn-outline-primary btn-lg" data-dismiss="modal" (click)="onCloseInvite()">
              <span i18n="@@author.button-label.cancel">Cancel</span>
            </button>
            <button type="button" class="btn btn-primary btn-lg gtmCreateNewAuthor" (click)="onInviteAuthor()">
              <span i18n="@@author.button-label.invite-author">Invite Author</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- invite store user success popup -->
<div class="container" *ngIf="showsuccessInvitePopup" id="inviteStorUsrCon">
  <div class="modal-backdrop show" id="modalBackDropStoreUsr"></div>
  <!-- The Modal -->
  <div class="modal" id="successAuthorModal">
    <div class="modal-dialog modal-lg" id="authorModalDialog">
      <div class="modal-content" id="authorModalCon">
        <div class="card invitePopup" id="authorCard">
          <div class="modal-header" id="authorModalHeader">
            <div class="invitesuccessmodal-close-icon" data-dismiss="modal" (click)="onCloseSuccessPopup()" id="onClosePopup"></div>
          </div>
          <!-- Modal body -->
          <div class="modal-body invitesuccess-panel" id="inviteSuccessPanel">
            <div class="invitesuccess_img_div text-center" id="inviteSuccessImg">
              <span class="invitesuccess_img"></span>
            </div>
            <div class="invitesuccess-title text-center" id="inviteSuccessTitle">
              <span i18n="@@author.success-popup.invite-sent">Invite Sent</span>
            </div>
            <div class="invitesuccess-content text-center" id="inviteSuccessContent"><span i18n="@@author.success-popup.invite-sent-desc">Invite sent to {{invitedEmailString}} to produce OEM
                content <div>for {{partner}}.</div></span></div>
          </div>
        </div>
      </div>
    </div>
    <!-- Popup Modal ends Here -->
  </div>
</div>

<div class="container" *ngIf="openDeleteModalPopup" id="deleteUsrCon">
  <div class="modal-dialog-centered" id="modalDialog">
      <div class="modal-backdrop show" id="modalShow"></div>
      <div class="modal" id="deleteUserModel">
          <div class="modal-dialog" id="deleteUsrModelDialog">
              <div class="modal-content" *ngIf="isDeleted" id="deleteUserModelCon">
                  <div class="modal_close_icons" data-dismiss="modal" (click)="closeDeleteUserModal()" id="modalCloseIcon">
                  </div>
                  <div class="modal-body" id="deleteUsrModelBody">
                      <div class="heading remove_heading" id="deleteUsrHeading">
                          <span class="remove_content_text" i18n="@@author.delete-popup.delete">Delete {{deleteMessage}} ?</span>
                      </div>
                      <p class="remove_text">
                        <span i18n="@@author.delete-popup.delete-desc">Are you sure you would like to remove {{deleteMessage}} from the Authors List?</span>
                    </p>
                  </div>
                  <div class="modal-footer" id="deleteUsrModelFooter">
                      <button type="button" class="btn btn-outline-primary btn-lg gtmUsersActiveUsersCancel" data-dismiss="modal"
                          (click)="closeDeleteUserModal()" ><span i18n="@@author.button-label.cancel">Cancel</span></button>
                      <button type="button" class="btn btn-primary btn-lg gtmUserDelete" (click)="deleteUser()"><span i18n="@@author.delete-popup-button-lable.delete-user">Delete User</span></button>
                  </div>
              </div>

        <div class="modal-content" *ngIf="!isDeleted" id="deleteUsrModelCon">
          <div class="card removePopup" id="deleteUsrCard">
            <div class="modal-header" id="deleteUsrModalHeader">
              <div class="removesuccessmodal-close-icon" data-dismiss="modal" (click)="closeDeleteUserModal()" id="removeDeleteModal"></div>
            </div>
            <div class="modal-body" id="delteUsrModalBody">
              <div class="removesuccess_img_div text-center" id="removeSuccessImg">
                <span class="removesuccess_img"></span>
              </div>
              <div class="removesuccess-title text-center" id="deleteMsg"><span i18n="@@author.delete-success-popup.successfully-deleted">{{deleteMessage}} successfully deleted</span></div>
              <div class="removesuccess-content text-center" id="removeSuccessCon">
                <span i18n="@@author.delete-success-popup.successfully-deleted-desc">{{deleteMessage}} has successfully been
                  removed from your Authors List.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
